(function( $ ) {
  $.fn.slide = function(opt) {
    let defaultOptions = {
      selectorFoActiveSlideButton: 'slide-link-active',
      selectorForActiveSlide:'slide-active',
      selectorForSlideLinks: '.slide-links',
      selectorForSlides: '.slides',
      attributeForTarget: 'data-target-slide',
    };

    let options = $.extend(defaultOptions, opt);

    const setFirstSlideActive = () => {
      // dont set active if it already contains a active link
      const activeSlideLinksCount = $(options.selectorForSlideLinks)
        .children(`.${options.selectorFoActiveSlideButton}`)
        .length

      if(activeSlideLinksCount === 0) {
        $(options.selectorForSlides).each(function(){
          $($(this).children()[0]).addClass(options.selectorForActiveSlide);
        });

        $(options.selectorForSlideLinks).each(function(){
          $($(this).children()[0]).addClass(options.selectorFoActiveSlideButton);
        });
      }
    }

    const resetActiveSlides = (slides, currentTarget) => {
      $(slides).children().each(function(){
        $(this).removeClass(options.selectorForActiveSlide);
      });

      $(currentTarget).siblings().each(function(){
        $(this).removeClass(options.selectorFoActiveSlideButton);
      });
    }

    this.on('click', (event) => {
      event.preventDefault();
      const targetIndex = $(event.currentTarget).attr(options.attributeForTarget);
      const slides = $(event.currentTarget).parent().siblings(options.selectorForSlides)[0];
      const targetSlide = $(slides).children()[targetIndex];
      resetActiveSlides(slides, event.currentTarget);

      $(event.currentTarget).addClass(options.selectorFoActiveSlideButton);
      $(targetSlide).addClass(options.selectorForActiveSlide);
    });

    setFirstSlideActive();
  }
}( jQuery ));
